import list from 'src/modules/escalation/list/escalationListReducers';
import form from 'src/modules/escalation/form/escalationFormReducers';
import view from 'src/modules/escalation/view/escalationViewReducers';
import destroy from 'src/modules/escalation/destroy/escalationDestroyReducers';
import importerReducer from 'src/modules/escalation/importer/escalationImporterReducers';
import { combineReducers } from 'redux';

export default combineReducers({
  list,
  form,
  view,
  destroy,
  importer: importerReducer,
});
